import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from './components/dumb-components/loading/loading.component';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, Toast],
  template: `
    <p-toast position="top-right"></p-toast>
    <router-outlet></router-outlet>
    <app-loading></app-loading>
  `,
})
export class App {}
